
import { defineComponent, ref, Ref } from "vue";
import NotificationButton from "./NotificationButton.vue";
import NotificationList from "./NotificationList.vue";

export default defineComponent({
  name: "Notification",
  components: { NotificationList, NotificationButton },
  setup() {
    const isOpened: Ref<boolean> = ref(false);

    const toggleNotificationModal = async () => {
      isOpened.value = !isOpened.value;
    };

    document.documentElement.onclick = async function(event: Event) {
      const list = document.querySelector("[data-notification-list]");
      const button = document.querySelector("[data-notification-button]");
      if (event.target === button) {
        await toggleNotificationModal();
      } else if (event.target !== list) {
        isOpened.value = false;
      }
    };

    return {
      isOpened,
      toggleNotificationModal
    };
  }
});
